<header class="header">
  <div class="header__navigation" [class]="{ 'header__navigation--with-menu': showMenu }">
    <div class="header__navigation-wrapper flex align-items-center">
      <span class="col-fixed py-0 pl-0 inline-flex align-items-center header__navigation-menu pointer"
        *ngIf="showMenu && userInformation.username != null">
        <i tabindex="0" class="fas fa-bars" (click)="displayMenu = true" (keypress)="onKeyEnter($event)"></i>
      </span>

      <span class="col py-0 inline-flex align-items-center justify-content-center md:justify-content-start">
        <a class="header__navigation-company pointer" [routerLink]="['/']">
          <img class="header__navigation-company-logo" src="assets/logo-white.png"
            alt="{{screenInformation.company}} logo white" />
          <span class="hide-on-small">
            {{screenInformation.company}}
          </span>
        </a>
      </span>

      <span class="col py-0 pr-0 inline-flex align-items-center justify-content-end">
        <a class="header__navigation-bell mr-3" *ngIf="turnsQuantity > 0" [routerLink]="['/turno']">
          {{turnsQuantity}}
          <i class="far fa-bell"></i>
        </a>

        <span class="header__navigation-user pointer hide-on-small" (click)="accountMenu.toggle($event)">
          {{userInformation.fullName}}
          <span class="header__navigation-user-menu md:pl-2">
            <i class="fas fa-user"></i>
          </span>
        </span>

      </span>
    </div>
  </div>

  <div class="header__page flex align-items-center" *ngIf="showHeading">
    <h1 class="header__page-heading">
      {{screenInformation.title}}
    </h1>
  </div>
</header>

<p-sidebar styleClass="header__options-sidebar px-0" [(visible)]="displayMenu" [showCloseIcon]="false"
  [blockScroll]="true">
  <div class="hide-from-small">
    <ng-template [ngTemplateOutlet]="accountMenuContent"></ng-template>
  </div>

  <ms-khuyana-header-menu [options]="options" [isDoctor]="userInformation.roles?.isDoctor"
    (leave)="displayMenu = false">
  </ms-khuyana-header-menu>
</p-sidebar>

<p-overlayPanel #accountMenu [dismissable]="true">
  <ng-template [ngTemplateOutlet]="accountMenuContent"></ng-template>
</p-overlayPanel>

<ng-template #accountMenuContent>
  <nav class="header__menu">
    <ul class="header__menu-list">
      <li
        class="col-12 py-0 px-3 header__menu-item header__menu-item--user-info header__menu-item--no-hover hide-from-small cursor-default pointer-events-none">
        <h3 class="header__menu-content" [style.width.%]="100">
          <span class="header__menu-content-text header__menu-content-text--no-hover">
            {{userInformation.fullName}}
          </span>
        </h3>
      </li>

      <li *ngIf="userInformation.roles?.isDoctor"
        class="col-12 py-0 px-0 header__menu-item header__menu-item--user-info" [routerLink]="[ '/cuenta' ]"
        (click)="accountMenu.hide(); displayMenu = false">
        <h3 class="header__menu-content" [style.width.%]="100">
          <a class="header__menu-content-text header__menu-content-text--rounded px-3">
            <i class="header__menu-content-icon fas fa-user-md"></i>Actualizar Información
          </a>
        </h3>
      </li>

      <li class="col-12 py-0 px-0 header__menu-item header__menu-item--logout hide-on-small" [routerLink]="[ '/salir' ]"
        (click)="accountMenu.hide(); displayMenu = false">
        <h3 class="header__menu-content" [style.width.%]="100">
          <a class="header__menu-content-text header__menu-content-text--rounded px-3">
            <i class="header__menu-content-icon fas fa-door-open mr-2"></i>Salir</a>
        </h3>
      </li>
    </ul>
  </nav>
</ng-template>